var map = {
	"./blocklistUrlInfoPopover.pug": 4511,
	"./whitelistFullDataInfoPopover.pug": 4512,
	"./whitelistUrlInfoPopover.pug": 4513,
	"./whitelistUserPromptsInfoPopover.pug": 4514
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4510;